import { EquipmentModelType } from '__generated__/graphql';
import { t } from 'utils/localize';

export const equipmentModelTypeLabelMap: Record<EquipmentModelType, string> = {
  [EquipmentModelType.Attachment]: t('Attachment'),
  [EquipmentModelType.Equipment]: t('Equipment'),
  [EquipmentModelType.Tool]: t('Tool'),
};

export const equipmentModelTypeStringMap: Record<string, EquipmentModelType> = {
  [EquipmentModelType.Attachment]: EquipmentModelType.Attachment,
  [EquipmentModelType.Equipment]: EquipmentModelType.Equipment,
  [EquipmentModelType.Tool]: EquipmentModelType.Tool,
};
